(function ($) {
	"use strict";
	$(document).ready(function () {
		$(".explore-slider_top").slick({
			dots: true,
			arrows: false,
			// adaptiveHeight: true,
			asNavFor: ".explore-slider-down, .explore-slider--right",
		});

		$(".explore-slider-down").slick({
			dots: false,
			arrows: false,
			asNavFor: ".explore-slider_top, .explore-slider--right",
		});

		$(".explore-slider--right").slick({
			dots: false,
			arrows: false,
			asNavFor: ".explore-slider_top, .explore-slider-down",
		});

		$(".testimonial-slider--video--wrapper").slick({
			dots: true,
			arrows: false,
		});
	});
})(jQuery);
